export interface FlashItem {
  id: string;
  time: string;
  text: string;
  event: string;
}

export const flashItems: FlashItem[] = [
  {
    id: 'fl-01',
    time: '17:10',
    text: '深渊王者赛冠军组对决结束，江辞团队协作评分走低，位列今日黑榜第六。',
    event: '深渊王者赛',
  },
  {
    id: 'fl-02',
    time: '15:30',
    text: '黎明锦标赛半决赛战毕，顾北决胜局命中率跌至三成，遗憾无缘决赛。',
    event: '黎明锦标赛',
  },
  {
    id: 'fl-03',
    time: '13:15',
    text: '雷霆竞技场新赛制首秀，沈墨失误统计居首，成为当日黑榜焦点。',
    event: '雷霆竞技场',
  },
  {
    id: 'fl-04',
    time: '11:40',
    text: '暗夜争霸赛小组赛第二轮，陆行舟承伤转化率不足四成，排名下滑三位。',
    event: '暗夜争霸赛',
  },
  {
    id: 'fl-05',
    time: '09:20',
    text: '星轨联赛第三赛段收官，林夜表现指数跌至赛季新低，登上今日黑榜首位。',
    event: '星轨联赛',
  },
];